import {
  CANCELLED_TAB_VALUE,
  FULLORDER_TAB_VALUE,
  INPROGRESS_TAB_VALUE,
  RETURNED_TAB_VALUE,
  SHIPPED_TAB_VALUE,
} from "@/components/OrderConfirmation/OrderDetailsTabs/constant"

const getTotalQuantity = (arr = []) =>
  arr.reduce((total, item) => {
    const itemQtySum = item.lineItems.reduce((sum, lineItem) => {
      if (lineItem.childItems && lineItem.childItems.length > 0) {
        // sum the quantities of child items if they exist
        return (
          sum +
          lineItem.childItems.reduce((childSum, child) => {
            return childSum + child.quantity
          }, 0)
        )
      } else {
        // otherwise, add the quantity of the line item itself
        return sum + lineItem.quantity
      }
    }, 0)
    return total + itemQtySum
  }, 0)

export const getOrderDetailsTabs = (data, staticText) => {
  const shippedItemsCount = getTotalQuantity(data[SHIPPED_TAB_VALUE])
  const inprogressItemsCount = getTotalQuantity(data[INPROGRESS_TAB_VALUE])
  const returnedItemsCount = getTotalQuantity(data[RETURNED_TAB_VALUE])
  const cancelledItemsCount = getTotalQuantity(data[CANCELLED_TAB_VALUE])

  return [
    {
      label: staticText.fullorderTabLabel,
      value: FULLORDER_TAB_VALUE,
    },
    {
      label: staticText.shippedTabLabel(shippedItemsCount),
      value: SHIPPED_TAB_VALUE,
    },
    {
      label: staticText.inprogressTabLabel(inprogressItemsCount),
      value: INPROGRESS_TAB_VALUE,
    },
    {
      label: staticText.returnedTabLabel(returnedItemsCount),
      value: RETURNED_TAB_VALUE,
    },
    {
      label: staticText.cancelledTabLabel(cancelledItemsCount),
      value: CANCELLED_TAB_VALUE,
    },
  ]
}

export const getTabHeaders = (
  staticText = {},
  tabname = "",
  lineItems = []
) => {
  const hasLineitems = lineItems.length > 0
  switch (tabname) {
    case CANCELLED_TAB_VALUE:
      return {
        tabTitle: staticText.cancelledTabHeading,
        tabSubtitle: staticText.cancelledTabSubHeading,
        noItemsDescription: staticText.noItemsCancelledText,
        hasLineitems,
      }
    case INPROGRESS_TAB_VALUE:
      return {
        tabTitle: staticText.inprogressTabHeading,
        tabSubtitle: staticText.inprogressTabSubHeading,
        noItemsDescription: staticText.noItemsInprogressText,
        hasLineitems,
      }

    case RETURNED_TAB_VALUE:
      return {
        tabTitle: staticText.returnedTabHeading,
        tabSubtitle: staticText.returnedTabSubHeading,
        noItemsDescription: staticText.noItemsReturnedText,
        hasLineitems,
      }
    default:
      return {
        tabTitle: "",
        tabSubtitle: "",
        noItemsDescription: "",
        hasLineitems: false,
      }
  }
}

export const handleInReviewContinueButton = (
  isMobile,
  phoneNumber,
  redirectUrl
) => {
  if (isMobile) {
    window.location.href = `tel:${phoneNumber}`
  } else {
    window.location.href = redirectUrl
  }
}
